<template>
    <base-modal
        :title="$t('materialstorage.amount_change_modal.title')"
        size="lg"
        :prevent-close="false"
        :allow-overflow="true"
        @ok="onOk"
        @close="onClose"
    >
        <div class="row">
            <div class="col-12">
                <h6 class="mb-2">
                    {{ $t('materialstorage.amount_change_modal.changed_records_heading') }}
                </h6>
                <table class="table table-sm table-bordered table-responsive">
                    <thead>
                        <tr>
                            <th>{{ $t('common.name') }}</th>
                            <th>{{ $t('materialstorage.amount_change_modal.old_amount') }}</th>
                            <th>{{ $t('materialstorage.amount_change_modal.new_amount') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(cr, index) in changedRecords"
                            :key="index"
                        >
                            <td>{{ cr.record.name }}</td>
                            <td>{{ cr.originalAmount }}</td>
                            <td>{{ cr.record.amount }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-12">
                <label class="form-label">{{ $t('materialstorage.amount_change_modal.info_label') }}</label>
                <textarea
                    v-model="info"
                    class="form-control"
                    maxlength="1000"
                    :placeholder="$t('materialstorage.amount_change_modal.info_placeholder')"
                />
                <div
                    v-if="validationError"
                    class="text-danger small mt-1"
                >
                    {{ $t('materialstorage.amount_change_modal.info_required') }}
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-12">
                <label class="form-label">{{ $t('materialstorage.amount_change_modal.contract_label') }}</label>
                <div
                    v-if="loadingContracts"
                    class="d-flex align-items-center mt-1"
                >
                    <span
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
                <multiselect
                    v-model="contract"
                    label="name"
                    track-by="id"
                    :options="contracts"
                    :placeholder="$t('common.select')"
                    :deselect-label="$t('common.remove_selection')"
                    :select-label="$t('common.select')"
                    :selected-label="$t('common.selected')"
                />
                <div
                    v-if="fetchError"
                    class="text-danger small mt-1"
                >
                    {{ $t('materialstorage.amount_change_modal.contracts_fetch_error') }}
                </div>
            </div>
        </div>
    </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: 'MaterialAmountChangeModal',
    components: {BaseModal},
    mixins: [restApi],
    props: {
        changedRecords: {
            type: Array,
            required: true
        }
    },
    emits: ['confirm', 'cancel'],
    data: function () {
        return {
            info: '',
            contract: null,
            contracts: [],
            loadingContracts: false,
            fetchError: false,
            validationError: false
        }
    },
    mounted: function () {
        this.fetchContracts()
    },
    methods: {
        fetchContracts: function () {
            this.loadingContracts = true
            this.fetchError = false
            this.restFetchParams(
                this.contractOpenUrl,
                { startDate: new Date().toISOString() },
                this.handleContracts,
                this.handleContractsFetchError
            )
        },
        handleContracts: function (response) {
            this.loadingContracts = false
            if (response && response.data) {
                this.contracts = response.data
            }
        },
        handleContractsFetchError: function () {
            this.loadingContracts = false
            this.fetchError = true
        },
        onOk: function () {
            if (!this.info || !this.info.trim()) {
                this.validationError = true
                return
            }
            this.validationError = false
            this.$emit('confirm', {
                info: this.info.trim(),
                contract: this.contract ? { id: this.contract.id, name: this.contract.name } : null
            })
        },
        onClose: function () {
            this.$emit('cancel')
        }
    }
}
</script>

<style scoped>
:deep(.multiselect__content-wrapper) {
    position: absolute;
    z-index: 1050;
    width: 100%;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
